module.exports = __webpack_public_path__ + "img/icon_manejo_tablas_meta.0f4882e8.svg";